import { render, staticRenderFns } from "./return_visit_table.vue?vue&type=template&id=143a8490&scoped=true"
import script from "./return_visit_table.vue?vue&type=script&lang=js"
export * from "./return_visit_table.vue?vue&type=script&lang=js"
import style0 from "./return_visit_table.vue?vue&type=style&index=0&id=143a8490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a8490",
  null
  
)

export default component.exports